import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Poppins } from 'src/common/Poppins';
import { Spacer } from 'src/common/Spacer';
import { MOTION_TRANSITION } from 'src/config';

const Header = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.7;
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.gp1};
    outline-offset: 4px;
    border-radius: 2px;
  }
`;

const Toggle = styled.svg`
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.cflowerBlue};
`;

interface ReviewSectionProps {
  label: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export const ReviewSection: React.FC<ReviewSectionProps> = ({ label, defaultOpen = true, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div>
      <Header type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <Poppins px={16} weight={600} color="cflowerBlue" css="text-transform: uppercase;">
          {label}
        </Poppins>
        <Toggle width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          {!open && (
            <path d="M12 5V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          )}
        </Toggle>
      </Header>
      <motion.div
        initial={false}
        animate={{ height: open ? 'auto' : 0 }}
        transition={MOTION_TRANSITION}
        style={{ overflow: 'hidden' }}
      >
        <Spacer $px={32} />
        {children}
      </motion.div>
    </div>
  );
};
